const _convertEmptyString = (value) => value === "" ? void 0 : value;
export const createGRN = (type, id) => `grn::::${type}:${id}`;
export const getValuesFromGRN = (grn) => {
  const grnValues = grn.split(":");
  const [resourceNameType, cluster, tenant, scope, type, id] = grnValues.map(_convertEmptyString);
  return { resourceNameType, cluster, tenant, scope, type, id };
};
